<ng-template vdrDialogTitle>{{ "shippingFee.import" | translate }}</ng-template>

<p>Your excel file should match the following format (Method is optional):</p>

<table
  style="
    width: 100%;
    margin-top: 16px;
    border: 1px solid black;
    border-collapse: collapse;
  "
>
  <tr>
    <th
      *ngIf="includeOrderColumn"
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      Order
    </th>
    <th
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      TrackingCode
    </th>
    <th
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      Method
    </th>
    <th
      *ngIf="!includeOrderColumn"
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      SKU
    </th>
    <th
      *ngIf="!includeOrderColumn"
      style="
        text-align: start;
        border: 1px solid black;
        border-collapse: collapse;
      "
    >
      Quantity
    </th>
  </tr>
  <tbody>
    <tr>
      <td
        *ngIf="includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        2DG1P7WKA14J36FP
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        ABC,DEC
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        Ship
      </td>
      <td
        *ngIf="!includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        250205WOBPip02
      </td>
      <td
        *ngIf="!includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        3
      </td>
    </tr>
    <tr>
      <td
        *ngIf="includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        11GN23UAKA14J36FP
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        ABC
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        Ship
      </td>
      <td
        *ngIf="!includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        250205WOBPip03
      </td>
      <td
        *ngIf="!includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        1
      </td>
    </tr>

    <tr>
      <td
        *ngIf="includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        89EXJ6LDAL58XKUU
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        DEF
      </td>
      <td
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        Ship
      </td>
      <td
        *ngIf="!includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        250205WOBPip03
      </td>
      <td
        *ngIf="!includeOrderColumn"
        style="
          text-align: start;
          border: 1px solid black;
          border-collapse: collapse;
        "
      >
        4
      </td>
    </tr>

    ...
  </tbody>
</table>

<div style="margin-top: 2rem; width: 100%">
  <!-- <input
    style="width: 100%; height: 2rem !important"
    id="fileUpload"
    type="file"
    multiple="false"
    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    (change)="handleFileInput($event.target.files)"
  /> -->

  <vdr-card *ngIf="fileUpload; else upload">
    {{ fileUpload.name }}
  </vdr-card>

  <ng-template #upload>
    <custom-asset-file-input
      [multiple]="false"
      [acceptTypes]="[
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-excel'
      ]"
      (selectFiles)="handleFileInput($event)"
    >
    </custom-asset-file-input>
  </ng-template>
</div>

<p style="color: red">{{ error }}</p>

<ng-template vdrDialogButtons>
  <button type="submit" (click)="cancel()" class="btn btn-secondary">
    {{ "common.cancel" | translate }}
  </button>
  <button
    type="submit"
    [disabled]="!fileUpload"
    (click)="import()"
    class="btn btn-primary"
  >
    {{ "common.import" | translate }}
  </button>
</ng-template>
